import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function Legend({ pmsColors }) {
  if (!pmsColors) return null;

  const STATUS_LABELS = {
    confirmed: 'Confirmada',
    tentative: 'Tentativa',
    cancelled: 'Cancelada',
    no_show: 'No Show',
    checked_in: 'In-House',
    checked_out: 'Checked Out',
    group: 'Grupo',
    walk_in: 'Walk-In'
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ overflowX: 'auto' }}>
      <Typography variant="caption" sx={{ fontWeight: 700, color: pmsColors.text.secondary, mr: 1 }}>
        ESTADOS:
      </Typography>

      {Object.entries(pmsColors.reservations).map(([key, color]) => (
        <Stack key={key} direction="row" spacing={0.5} alignItems="center">
          <Box sx={{ width: 10, height: 10, backgroundColor: color, borderRadius: '2px' }} />
          <Typography variant="caption" sx={{ color: pmsColors.text.primary, fontSize: '0.7rem' }}>
            {STATUS_LABELS[key] || key}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
